import React, { useContext } from 'react';
import { AppContext } from '../context/AppContext';
import { Page } from '../types';
import CrystalTheme from '../components/home_themes/CrystalTheme';
import { lazyRetry } from '../utils/lazyRetry';

// Crystal is the certified active first-paint theme. The alternate theme keeps
// its full behavior but no longer inflates every Crystal homepage boot.
const PrismaTheme = lazyRetry(() => import('../components/home_themes/PrismaTheme'));

const HomePage: React.FC = () => {
    const context = useContext(AppContext);
    
    if (!context) {
        return null;
    }

    const { 
        repairData = [], 
        setSelectedBrand = () => {}, 
        setPage = () => {},
        activeThemeConfig
    } = context;

    const handleSelectBrand = (brandId: string) => {
        const brandObj = repairData.find(b => b.id === brandId);
        if (brandObj) {
            setSelectedBrand(brandObj);
        }
        setPage(Page.Repairs);
    };

    const layoutType = activeThemeConfig?.layoutType;

    return (
        <div className="relative w-full h-full">
            {layoutType === 'prisma' ? (
                <PrismaTheme repairData={repairData} handleSelectBrand={handleSelectBrand} setPage={setPage} PageTypes={Page} />
            ) : (
                <CrystalTheme repairData={repairData} handleSelectBrand={handleSelectBrand} setPage={setPage} />
            )}
        </div>
    );
};

export default HomePage;
